module.exports = __webpack_public_path__ + "static/media/insect(12).6616543c.PNG";